<app-desktop-table [data]="data"
                   [totalCount]="totalCount"
                   [expandedComponent]="expandedComponent"
                   *ngIf="!handsetService.isMobile || disabledMobileView"
                   [columns]="columns"
                   (addedSelection) = addedSelection.emit($event);
                   (removedSelection) = removedSelection.emit($event);
                   (rowOnclick)="rowOnclick.next($event)"
                   [hover]="hover"
                   [editable]="editable"
                   [pageable]="pageable"
                   [expandedElement]="expandedElement"
                   [isFloatingMenu]="isFloatingMenu"
                   [selection]="selection"
                   [isSelectable]="isSelectable"
                   [multiselectDisabled]="multiselectDisabled"
                   [rowStyle]="rowStyle"
                   [validation]="validation"
                   (dataChangedEvent)="dataChangedEvent.emit($event)"
                   (pageEvent)="pageEvent.emit($event)"
                   [isExpandable]="isExpandable">
</app-desktop-table>
<app-mobile-table [data]="data"
                  *ngIf="handsetService.isMobile && !disabledMobileView"
                  [columns]="columns"
                  [expandedComponent]="expandedComponent"
                  (addedSelection) = addedSelection.emit($event);
                  (removedSelection) = removedSelection.emit($event);
                  (rowOnclick)="rowOnclick.next($event)"
                  [hover]="hover"
                  [expandedElement]="expandedElement"
                  [isFloatingMenu]="isFloatingMenu"
                  [isExpandable]="isExpandable"
                  [hideHeader]="hideMobileHeader"
                  [isSelectable]="isSelectable"
                  [multiselectDisabled]="multiselectDisabled"
                  [rowStyle]="rowMobileStyle"
                  [selection]="selection"
                  [showInformation]="showInformation">
  <ng-container mobileFilters>
    <ng-content select="[mobileFilters]">
    </ng-content>
  </ng-container>
  <ng-container mobileHeader>
    <ng-content select="[mobileHeader]">
    </ng-content>
  </ng-container>
</app-mobile-table>
